import { Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

declare const $: any;

export interface ModalConfig {
    backdrop?: 'static' | boolean;
    keyboard?: boolean;
    size?: 'sm' | 'lg' | '';
    centered?: boolean;
}

@Component({
    selector: 'app-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements AfterViewInit, OnDestroy {
    @Input() modalId!: string;
    @Input() title = '';
    @Input() showHeader = true;
    @Input() showFooter = true;
    @Input() size: 'sm' | 'lg' | '' = '';
    @Input() config: ModalConfig = {
        backdrop: 'static',
        keyboard: false
    };

    @Output() modalClosed = new EventEmitter<void>();
    @Output() modalOpened = new EventEmitter<void>();

    private modalElement: any;

    ngAfterViewInit(): void {
        if (!this.modalId) {
            console.error('Modal component requires a modalId');
            return;
        }

        this.modalElement = $(`#${this.modalId}`);

        // Set up event listeners
        this.modalElement.on('shown.bs.modal', () => {
            this.modalOpened.emit();
        });

        this.modalElement.on('hidden.bs.modal', () => {
            this.modalClosed.emit();
        });
    }

    ngOnDestroy(): void {
        if (this.modalElement) {
            this.modalElement.off('shown.bs.modal');
            this.modalElement.off('hidden.bs.modal');
            // Clean up if modal is still open
            if (this.modalElement.hasClass('in')) {
                this.modalElement.modal('hide');
            }
        }
    }

    open(): void {
        if (this.modalElement) {
            this.modalElement.modal({
                backdrop: this.config.backdrop,
                keyboard: this.config.keyboard,
                show: true
            });
        }
    }

    close(): void {
        if (this.modalElement) {
            this.modalElement.modal('hide');
        }
    }

    get sizeClass(): string {
        return this.size ? `modal-${this.size}` : '';
    }
}
